import {applyMiddleware, createStore, combineReducers} from "redux";
import {createLogger} from "redux-logger";
import thunk from "redux-thunk";
import promise from "redux-promise-middleware";

import UserReducers from './reducers/UserReducers';
import LeaguesReducers from './reducers/LeaguesReducers';
import ModalsReducers from './reducers/ModalsReducers';
import AlertsReducer from './reducers/AlertsReducers';

import NotificationsReducers from './reducers/NotificationsReducers';
import MatchesReducers from './reducers/MatchesReducers';
import TransactionsReducers from './reducers/TransactionsReducers';
import LeaderBoardReducers from './reducers/LeaderBoardReducers';
import EntryReducers from './reducers/EntryReducers';

import RewardReducers from "./reducers/RewardsReducers";
import SponsorsReducers from "./reducers/SponsorsReducer";
import CacheReducers from "./reducers/CacheReducers";
import CCNavigationReducers from "./reducers/CCNavigationReducers";



const reducers = combineReducers({
    user: UserReducers,
    cache : CacheReducers,

    navigation : CCNavigationReducers,
    modals: ModalsReducers,
    alerts: AlertsReducer,

    leagues: LeaguesReducers,
    entries: EntryReducers,
    matches: MatchesReducers,
    leaderBoard: LeaderBoardReducers,
    notifications: NotificationsReducers,
    transactions: TransactionsReducers,
    rewards : RewardReducers,
    sponsors : SponsorsReducers
});

const ccMiddleWare = (store) => (next) => (action) => {
    if (action.type && action.type.includes('_FULFILLED')) {
        if (action.payload && action.payload.data) {
            if (action.payload.data.success || action.payload.data.statusCode === 'S1000') {
                next({...action, type: action.type.split('_FULFILLED')[0] + '_CC_FULFILLED'});
            }
            else {
                next(action);
            }
        }
        else {
            next(action);
        }
    }
    else {
        next(action);
    }
};

let middleware = applyMiddleware(promise(), ccMiddleWare, thunk);
if (process.env.NODE_ENV === 'development') {
    middleware = applyMiddleware(promise(), ccMiddleWare, thunk, createLogger());
}


const store = createStore(reducers, middleware);

export default store;


// WEBPACK FOOTER //
// ./src/app/data/CCStore.js